import { useState } from "react";
import { CalendarClock } from "lucide-react";
import { Button } from "@/components/ui/button";

const iso = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
const plusDays = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return iso(d); };

// Shared "Pending – follow-up needed" form (in-app workflow bar + public one-tap page).
export default function PendingForm({ reasons, onSubmit, onCancel, busy, initialReason = "", withNote = false, prefix = "workflow", submitLabel = "Mark pending" }) {
  const [reason, setReason] = useState(initialReason);
  const [date, setDate] = useState(plusDays(3));
  const [note, setNote] = useState("");
  const fieldCls = "block w-full h-10 rounded-md bg-slate-900/60 border border-white/10 px-2 text-sm";
  return (
    <div className="space-y-3 rounded-lg border border-orange-500/30 bg-orange-500/5 p-3" data-testid={`${prefix}-pending-block`}>
      <div className="flex items-center gap-2 text-orange-300 text-sm font-semibold">
        <CalendarClock className="w-4 h-4" /> Pending – follow-up needed
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <label className="space-y-1">
          <span className="text-xs uppercase tracking-wide text-muted-foreground font-mono">Pending on *</span>
          <select value={reason} onChange={(e) => setReason(e.target.value)} data-testid={`${prefix}-pending-reason`} className={fieldCls}>
            <option value="">Select what it's waiting on…</option>
            {(reasons || []).map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </label>
        <label className="space-y-1">
          <span className="text-xs uppercase tracking-wide text-muted-foreground font-mono">Follow-up date *</span>
          <input type="date" value={date} min={plusDays(0)} max={plusDays(180)} onChange={(e) => setDate(e.target.value)}
                 data-testid={`${prefix}-pending-date`} className={`${fieldCls} font-mono`} />
        </label>
      </div>
      {withNote && (
        <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} data-testid={`${prefix}-pending-note`}
                  placeholder="Optional note (what's needed, who is following up)…"
                  className="w-full rounded-md bg-slate-900/60 border border-white/10 px-2 py-1.5 text-sm" />
      )}
      <p className="text-[11px] font-mono text-muted-foreground">The receiving contact is emailed a reminder on the follow-up date.</p>
      <div className="flex items-center gap-3">
        <Button onClick={() => onSubmit({ pending_reason: reason, followup_date: date, note: note.trim() || undefined })}
                disabled={busy || !reason || !date} data-testid={`${prefix}-pending-submit`}
                className="bg-orange-500 hover:bg-orange-400 text-slate-950 font-semibold">{busy ? "Saving…" : submitLabel}</Button>
        <button onClick={onCancel} data-testid={`${prefix}-pending-cancel`} className="text-xs font-mono text-muted-foreground hover:text-foreground">cancel</button>
      </div>
    </div>
  );
}
